<template>
  <el-dialog
    center
    width="600px"
    :title="dialogTitle"
    :visible.sync="dialogFormVisible"
    @close="resetFrom('editForm')"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <!-- <el-form-item
        label="所属楼盘"
        :label-width="formLabelWidth"
        prop="houseId"
      >
        <el-select
          v-model="editForm.houseId"
          filterable
          placeholder="请选择楼盘"
        >
          <el-option
            v-for="item in houseData"
            :key="item.houseId"
            :label="item.houseName"
            :value="item.houseId"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="主播" :label-width="formLabelWidth" prop="userId">
        <el-select
          v-model="editForm.userId"
          filterable
          remote
          placeholder="请输入主播姓名"
          :remote-method="searchUser"
          clearable
          @clear="editForm.userId = ''"
          :loading="loading"
        >
          <el-option
            v-for="item in anchorList"
            :key="item.value"
            :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="管理员"
        :label-width="formLabelWidth"
        prop="adminInfo"
      >
        <el-select
          v-model="editForm.adminInfo"
          style="width: 100%"
          multiple
          filterable
          remote
          placeholder="请选择管理员"
          :remote-method="searchAdmin"
          clearable
          @clear="editForm.adminInfo = []"
          :loading="loading"
        >
          <el-option
            v-for="item in adminOptions"
            :key="item.value"
            :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="直播时间"
        :label-width="formLabelWidth"
        prop="liveTime"
      >
        <el-date-picker
          class="search-picker"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="editForm.liveTime"
          type="datetime"
          placeholder="选择日期"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="预告标题" :label-width="formLabelWidth" prop="title">
        <el-input v-model="editForm.title" auto-complete="off"></el-input>
      </el-form-item>

      <el-form-item label="预告图片" :label-width="formLabelWidth" prop="photo">
        <el-upload
          class="avatar-uploader"
          :action="actionUrl"
          :show-file-list="false"
          :http-request="httpRequest"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="editForm.photo" :src="editForm.photo" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="观看人数基数"
        :label-width="formLabelWidth"
        prop="visitorBaseCount"
      >
        <el-input v-model="editForm.visitorBaseCount" type="number"></el-input>
      </el-form-item>
      <el-form-item
        label="预告内容"
        :label-width="formLabelWidth"
        prop="introduce"
      >
        <el-input
          v-model="editForm.introduce"
          type="textarea"
          :rows="4"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="回放地址"
        :label-width="formLabelWidth"
        prop="playbackAddress"
      >
        <el-input
          v-model="editForm.playbackAddress"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="预告备注"
        :label-width="formLabelWidth"
        prop="remark"
      >
        <el-input
          v-model="editForm.remark"
          type="textarea"
          :rows="2"
          auto-complete="off"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          resetFrom('editForm');
          dialogFormVisible = false;
        "
        >取 消</el-button
      >
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formData, formRules } from '../form.js';
import { getAllUsers } from '@/api/allUser.js';
import { decrypt } from '@/utils/encryp';
import { getUserModelApi } from '@/api/user.js';
import { getToken } from '@/utils/token';
import { liveUpload, addAdvanceNotice, editAdvanceNotice } from '@/api/live.js';

export default {
  data() {
    return {
      liveAdvanceNoticeId: '',
      houseId: '',
      dialogTitle: '',
      dialogFormVisible: false,
      actionUrl: '',
      editForm: { ...formData },
      editRules: formRules,
      formLabelWidth: '120px',
      houseData: [],
      anchorList: [], // 主播列表
      adminInfo: [],
      adminOptions: [],
      loading: false,
    };
  },
  inject: ['reload'],
  mounted() {
    // this.getUser();
    console.log('editform', this.anchorList);
  },
  methods: {
    // 处理解密
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 搜索用户名
    async searchUser(val) {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      this.anchorList = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    // 选择主播下拉选项
    checkServicePerson(val) {
      this.editForm.userId = val;
    },
    // 选择管理员
    async searchAdmin(val) {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      this.adminOptions = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    async getUser() {
      try {
        await getAllUsers().then((res) => {
          this.adminOptions = res.data;
          // console.log('adminOptions', this.adminOptions);
        });
      } catch (err) {
        window.console.log(err);
      }
    },
    resetFrom(formName) {
      // 清空表单
      this.$refs[formName].resetFields();
      this.editForm = {};
    },
    // 上传图片前验证规则
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      //const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      /*  if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M; */
      return isJPG;
    },
    httpRequest(options) {
      let file = options.file;
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
      }
      reader.onload = () => {
        let base64Str = reader.result;
        this.dealImg(options, base64Str, file);
      };
    },
    dealImg(options, base64Str, file) {
      let _this = this;
      var image = new Image();
      image.src = base64Str;
      image.setAttribute('crossOrigin', 'Anonymous');

      image.onload = function () {
        // 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        // 图片原始尺寸
        var originWidth = this.width;
        var originHeight = this.height;

        // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
        var maxWidth = 4200,
          maxHeight = 4200;
        // 目标尺寸
        var targetWidth = originWidth,
          targetHeight = originHeight;
        // 图片尺寸超过300x300的限制
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > maxWidth / maxHeight) {
            // 更宽，按照宽度限定尺寸
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        // canvas对图片进行缩放
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        // 清除画布
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 图片压缩
        context.drawImage(image, 0, 0, targetWidth, targetHeight);
        /*第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高*/

        //压缩后的图片转base64 url
        /*canvas.toDataURL(mimeType, qualityArgument),mimeType 默认值是'image/png';
         * qualityArgument表示导出的图片质量，只有导出为jpeg和webp格式的时候此参数才有效，默认值是0.92*/
        var base64 = canvas.toDataURL('image/jpeg', 0.92); //base64 格式
        liveUpload({
          base64String: base64,
          fileName: file.name,
        })
          .then((res) => {
            // this.$set()
            // this.editForm.pic = res.data
            _this.$set(_this.editForm, 'photo', res.data.absoluteFileUrl);
          })
          .catch((err) => {
            window.console.log(err);
          });
      };
    },

    async submitEdit() {
      const userInfo = JSON.parse(getToken('userInfo'));
      if (userInfo) {
        this.editForm.houseId = userInfo.houseId;
      }
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');
          this.editForm.adminInfo = this.editForm.adminInfo.toString();
          if (this.liveAdvanceNoticeId != '') {
            await editAdvanceNotice(this.liveAdvanceNoticeId, {
              ...this.editForm,
            }).then((res) => {
              if (res.code === 200) {
                this.$message.success('编辑成功!');
              } else {
                this.$message.error('编辑失败!');
                return;
              }
            });
          } else {
            const areaId = localStorage.getItem('areaId')
              ? JSON.parse(localStorage.getItem('areaId')).areaId
              : '';
            await addAdvanceNotice({ ...this.editForm, areaId }).then((res) => {
              if (res.code === 200) {
                this.$message.success('添加成功!');
              } else {
                this.$message.error('添加失败!');
                return;
              }
            });
          }
          this.dialogFormVisible = false;
          this.editForm = {};
          this.reload();
        });
      } catch (err) {
        window.console.log(err);
      }
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}
.avatar {
  width: 100px;
  display: block;
}
</style>
